module.exports = __webpack_public_path__ + "img/1.4d350588.png";